const Filters = require('./Filters.js');
const generalEvents = require('../events/general-events.js');
const _ = require('lodash');
const isMobile = require('is-mobile');
// funcao para ver se alguma variavel nao esta definida
const isUndefined = require('lodash/isUndefined');

const ReportsActions = (function () {
  const container = $('#reports-container');
  const filtersContainer = $('#reports-filters');
  ReportsActions.URL = /^\/relatorios(\/\d+)?/;

  function ReportsActions() {
    const _this = this;
    const filters = new Filters(route('app.relatorios.filtrar'), filtersContainer);

    nifty.body.overlay({ fixed: true });
    init.call(this)

    filters.before = function () {
      nifty.body.overlay('show');
    };

    filters.after = function (html) {
      _this.resetDataView(html)
    };

    if (isMobile()) {
      this.modalFilters = $('#modal-filter');
      this.modalFilters
        .find('.modal-body')
        .html(filtersContainer.closest('.panel-body'))
        .find('.panel-header')
        .remove();
    }
  }

  ReportsActions.prototype.resetDataView = function (html) {
    const _this = this;
    if (html) {
      if (isMobile()) {
        html = $(html);
        const itens = html.find('.mobile-grid__item');
        $('.mobile-grid__item-container').html(itens.length ? itens : html);
        this.modalFilters.modal('hide');
      } else {
        container.html(html);
      }
      init.call(this);
      nifty.body.overlay('hide');
      return this;
    }

    container.load(ReportsActions.URL, function () {
      init.call(_this);
    });

    return this;
  };

  ReportsActions.prototype.isApprovalByCostCenter = function (elEmpresaPagante) {
    const approvalType = elEmpresaPagante.getAttribute('data-approval-type');
    if (approvalType == 'CC') {
      return true;
    }
    return false;
  }

  // Funcao para preencher um campo de rateio com o rateio padrao
  const preencheProjetoPadrao = function (target, projetos) {
    // Rateio padrao
    const item = projetos[0];
    // Select do rateio obrigatorio
    const select = target.querySelector('[id^="idEmpresaReembolsante"]');
    // Se nao existe a opcao do rateio padrao no select
    // -> cria a opcao e adiciona no select e no selectize
    if (
      !($('#' + select.id + ' option[value="' + item.idEmpresaReembolsante.toString() + '"')
        .length != 0)
    ) {
      const newOption = document.createElement('option');
      newOption.value = item.idEmpresaReembolsante;
      newOption.innerText = item.reembolsante.nome;
      select && select.appendChild(newOption);
      select.selectize.addOption(newOption);
    };
    // Seleciona a opcao do rateio padrao
    select.selectize.setValue(item.idEmpresaReembolsante);
  }

  // Funcao para colocar o rateio padrao em um determinado campo
  // quando o botao de acao foi clicado
  const setProjetoPadrao = function (target, projetos) {
    const group = target.querySelector('[id^="group"]');
    // Se NAO existe algum campo de rateio
    // -> cria um campo de rateio
    if (!group || group.length < 1) {
      // Pega o botao de adicionar um novo rateio
      const $buttonAddProject = $(target).find('#novosRateios button');
      if (!$buttonAddProject) { return }
      // Clica no botao para adicionar um novo rateio
      $buttonAddProject.trigger('click');
    }
    // Preenche o campo de rateio
    preencheProjetoPadrao(target, projetos);
  }

  const init = function () {
    generalEvents();
    nifty.body.overlay('hide');
    document.querySelectorAll('[data-set-field-modal]')
      .forEach(function (el) {
        const target = document.querySelector(el.dataset.bsTarget);
        const selectizeReport = target.querySelector('#idDespesa').selectize;
        const selectizeEmpresaPagante = target.querySelector('#idEmpresaPagante').selectize;
        const selectizePagamentoForma = target.querySelector('[name=idPagamentoForma]').selectize;
        const cardsPaymentMethod = el.dataset.cardsPaymentMethod;

        const elEmpresaPagante = target.querySelector('#idEmpresaPagante');

        el.addEventListener('click', function () {
          selectizeReport.setValue(el.dataset.id, true);
          selectizeEmpresaPagante.setValue(el.dataset.idEmpresaPagante, true);

          if (el.dataset.idPagamentoForma != cardsPaymentMethod) {
            selectizePagamentoForma.setValue(el.dataset.idPagamentoForma, false);
          }

          const approvalType = elEmpresaPagante.getAttribute('data-approval-type');
          if (approvalType == 'CC') {
            elEmpresaPagante.setAttribute('data-rule-required', false);
            selectizeEmpresaPagante.disable();
            elEmpresaPagante.disabled = false;
          }

          // Definir os rateios padroes na criacao de despesas e percursos
          // na view index de relatorios
          if (!isUndefined(window.rateiosPadraoEmpresas) && window.rateiosPadraoEmpresas[el.dataset.id].length > 0) {
            setProjetoPadrao(target, window.rateiosPadraoEmpresas[el.dataset.id]);
          }
          // Definir os rateios padroes na criacao de despesas e percursos
          // na view show de relatorios
          if (!isUndefined(window.rateiosPadrao) && window.rateiosPadrao.length > 0) {
            setProjetoPadrao(target, window.rateiosPadrao);
          }
        }, false);
      });
  };

  return ReportsActions;
}());

module.exports = ReportsActions;
